import React from 'react'
import SendToPayButton from '../forms/sendToPay/SendToPayButton'
import { useSelector } from 'react-redux'
import AgreeLeaderButton from '../forms/agreeLeader/AgreeLeaderButton'

const SupplyBillsOptions = () => {

	const user = useSelector(state => state.user.user)
	const roles = ['SUPERADMIN', 'ADMIN']

	console.log('user', user)

  return (
    <div className='myBlockHeader__options'>
        <SendToPayButton />
		{
			user && roles.includes(user.role) ?
				<AgreeLeaderButton />
			: ''
		}
    </div>
  )
}

export default SupplyBillsOptions